import { buildModuleApi } from "../../../../../_CORE/API/_ApiUtil/_buildModuleApi";

const EXCLUDE_BULK = [
    "ARCHIVE", "RESTORE", "ARCHIVED", "BULK_CREATE", "BULK_ARCHIVE",
    "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM",
];

const COMPANIES = buildModuleApi({
    prefix: "COMPANIES", uri: "companies", withExtra: false, exclude: EXCLUDE_BULK,
    overrides: {
        LIST: { url: "/companies" },
        CREATE: { url: "/companies" },
        UPDATE: { url: "/companies" },
        REMOVE: { url: "/companies" },
        DETAIL: { url: "/companies/:id" },
    },
    extraActions: {
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

const VAULT = buildModuleApi({
    prefix: "VAULT", uri: "vault", withExtra: false,
    exclude: [...EXCLUDE_BULK, "LIST", "CREATE", "UPDATE", "REMOVE", "DETAIL"],
    extraActions: {
        GROUP_CREATE: { suffix: "/groups" },
        GROUP_BY_COMPANY: { suffix: "/groups/company/:companyId" },
        GROUP_DETAIL: { suffix: "/groups/:id" },
        GROUP_UPDATE: { suffix: "/groups" },
        GROUP_REMOVE: { suffix: "/groups" },
        GROUP_VERIFY_PIN: { suffix: "/groups/:id/verify-pin" },
        GROUP_ARCHIVE_LIST: { suffix: "/groups/archived/list" },
        GROUP_ARCHIVE: { suffix: "/groups/:id/archive" },
        GROUP_RESTORE: { suffix: "/groups/:id/restore" },
        ENTRY_ARCHIVE_LIST: { suffix: "/entries/archived/list" },
        ENTRY_CREATE: { suffix: "/entries" },
        ENTRY_UPDATE: { suffix: "/entries" },
        ENTRY_REMOVE: { suffix: "/entries" },
        ENTRY_REVEAL: { suffix: "/entries/:id/reveal" },
        ENTRY_ARCHIVE: { suffix: "/entries/:id/archive" },
        ENTRY_RESTORE: { suffix: "/entries/:id/restore" },
        FILE_ARCHIVE_LIST: { suffix: "/files/archived/list" },
        FILE_UPLOAD: { suffix: "/files/upload" },
        FILE_DOWNLOAD: { suffix: "/files/:id/download" },
        FILE_ARCHIVE: { suffix: "/files/:id/archive" },
        FILE_RESTORE: { suffix: "/files/:id/restore" },
        FILE_REMOVE: { suffix: "/files" },
    },
});

export const COMPANIES_API = COMPANIES.API;
export const COMPANIES_CONSTANTS = COMPANIES.CONSTANTS;
export const COMPANIES_PERMISSIONS = COMPANIES.PERMISSIONS;

export const VAULT_CONSTANTS = VAULT.CONSTANTS;

export const COMPANIES_ENDPOINTS = { ...COMPANIES.ENDPOINTS, ...VAULT.ENDPOINTS };
